import { CustomerAddressEntity } from '../entities/customer-address-entity';

export default class State {
  loaded = false;

  items: Array<CustomerAddressEntity> = [];
}
